import CarbonEmissionPanel from "@components/Review/CarbonEmissionPanel";
import Header from "@components/Review/Header";
import { useTranslation } from "react-i18next";

import ComparisonDatabase from "@/components/Review/ComparisonDatabase";
import SectorComparison from "@/components/Review/SectorComparison";

import { useReviewContext } from "./Review";

export const handle = {
  breadcrumb: ({ reviewId: paramsReviewId }: { reviewId: string }) => {
    const reviewId = paramsReviewId ?? localStorage.getItem("currentReviewId");
    return [
      {
        href: `/reviews/${reviewId}`,
        label: `navigation-menu:pages.analyse`,
      },
    ];
  },
};

function ReviewIndex() {
  const { reviewData, industryData } = useReviewContext();

  const { t, i18n } = useTranslation(["common", "review"]);

  if (!reviewData || !industryData) {
    return (
      <div className="grid place-items-center">
        <p>{t("common:loading")}</p>
      </div>
    );
  }

  const {
    carbon,
    employees,
    turnover,
    company_name: companyName,
    period_start: periodStart,
    period_end: periodEnd,
    show_comparison: showComparison,
  } = reviewData;

  const { title_en, title_fr, comparison } = industryData;

  return (
    <>
      <Header
        companyName={companyName}
        periodStart={periodStart}
        periodEnd={periodEnd}
      />
      <div className="gap-y-sm lg:gap-md grid xl:grid-cols-[1fr_3fr]">
        <div className="xl:col-span-full">
          <CarbonEmissionPanel data={reviewData} />
        </div>
        {showComparison && (
          <>
            <div className="xl:order-last">
              <SectorComparison
                carbon={carbon}
                employees={employees}
                turnover={turnover}
                comparison={comparison}
              />
            </div>
            <ComparisonDatabase
              title={i18n.language === "en" ? title_en : title_fr}
              comparison={comparison}
            />
          </>
        )}
      </div>
    </>
  );
}

export default ReviewIndex;
